/**
 * MagnetPostLinkedIn — LinkedIn poszt-flow.
 *
 * Vékony wrapper a MagnetPostFacebook komponens fölött `platform="linkedin"`
 * propal. A LinkedIn ügynök TELJES IDENTIKUS REPLIKÁCIÓJA a Facebook
 * Posztvarázslónak: ugyanaz a Topic Generator v2, ugyanaz az Outline
 * Generator v2, ugyanaz a hook-lock, ugyanaz a 30-mezős mentés, ugyanaz a
 * UI. Az EGYETLEN különbség a Writer Master System Prompt LinkedIn-
 * specifikus változata (backend oldali; `master_prompt_li.py`).
 *
 * A platform prop drive-olja:
 * - az API útvonalakat (`/attraction/post-linkedin/*`)
 * - az eyebrow strip-et (`VONZÁS · 01 · POSZT · LINKEDIN`)
 * - a fő címet (`LinkedIn poszt`)
 * - a mentett blueprint `forras_alkartya: "linkedin"` mezőjét
 * - a letöltött fájl nevét (`linkedin-poszt-<tema>.txt`)
 *
 * Minden egyéb (Quick Buttons, finomítás, Tudástár mentés, post_title H1,
 * meta-sor, gomb stílusok, animációk) változatlan.
 */
import MagnetPostFacebook from "./MagnetPostFacebook";

export default function MagnetPostLinkedIn(props) {
  return <MagnetPostFacebook {...props} platform="linkedin" />;
}
